import { eventBus } from '../main';
import { groupsMixin } from './groups-mixin';
import DeleteGroupConfirmModal from '../components/modals/DeleteGroupConfirmModal';

export const deleteGroup = {
  mixins: [groupsMixin],
  data() {
    return {
      /* Used on Groups index page since there are many groups that could be deleted and groupId is set dynamically. */
      groupToDelete: '',
      submittingGroupDelete: false,
    };
  },
  methods: {
    onConfirmDeleteGroup(groupId) {
      const vm = this;
      vm.submittingGroupDelete = true;
      vm.$store.dispatch('deleteGroup', groupId)
        .then((response) => {
          eventBus.$emit('groupDeleted', response, groupId);
          if (this.$router.currentRoute.name === 'GroupDashboard') {
            this.$router.push({ name: 'Groups' });
          }
        })
        .finally(() => {
          vm.groupToDelete = '';
          vm.submittingGroupDelete = false;
          vm.scrollToElement('sta-alert');
        });
    },
  },
  components: {
    DeleteGroupConfirmModal,
  },
};



// WEBPACK FOOTER //
// ./src/util/delete-group-mixin.js